import { StyleConfigSpec, } from '../parsing/UiTypesSpec';
var countChanges = function (config) {
    if (config === undefined || config === null) {
        return 0;
    }
    if (Array.isArray(config)) {
        return config.length === 0 ? 0 : 1;
    }
    if (typeof config === 'object') {
        var keys = Object.keys(config);
        if (keys.includes('added') && keys.includes('removed')) {
            var listDiff = config;
            return countChanges(listDiff.added) + countChanges(listDiff.removed);
        }
        return Object.keys(StyleConfigSpec.shape).reduce(function (acc, key) {
            return acc + countChanges(config[key]);
        }, 0);
    }
    return 1;
};
export var countConfigChanges = function (config, moduleMacronames) {
    var _a;
    if (moduleMacronames === void 0) { moduleMacronames = []; }
    return Object.keys((_a = config.inputConfigs) !== null && _a !== void 0 ? _a : {})
        .filter(function (macroName) {
        if (moduleMacronames.length === 0) {
            return true;
        }
        else {
            return moduleMacronames.includes(macroName);
        }
    })
        .map(function (macroName) {
        var _a;
        var inputConfig = (_a = config.inputConfigs) === null || _a === void 0 ? void 0 : _a[macroName];
        var count = countChanges(inputConfig);
        return count;
    })
        .reduce(function (acc, count) {
        return acc + count;
    }, 0);
};
